export const GRAPHQL_HOMEPAGE_API_REQUEST = "GRAPHQL_HOMEPAGE_API_REQUEST";
export const GRAPHQL_HOMEPAGE_API_SUCCESS = "GRAPHQL_HOMEPAGE_API_SUCCESS";
export const GRAPHQL_HOMEPAGE_API_FAILED = "GRAPHQL_HOMEPAGE_API_FAILED";

export const HEADER_BANNER_CMS_BLOCK_SUCCESS =
  "HEADER_BANNER_CMS_BLOCK_SUCCESS";
export const HEADER_BANNER_CMS_BLOCK_FAILED = "HEADER_BANNER_CMS_BLOCK_FAILED";
